import React, { useMemo } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// What the import actually did, one line per row sent.
//
// Every message shown here comes from the response. The backend knows whether somebody was created,
// updated, invited or refused, and it owns the wording; composing a message here would be a second
// version of the truth that drifts the moment the rules change.

const GRID_MAX_HEIGHT = "50vh";

export default function LcvParticipantImportResults(props) {
     const { result, onDone } = props;

     const rows = useMemo(
          () =>
               (result?.rows || []).map((row) => ({
                    ...row,
                    outcome: row.isSkipped ? "Ignored" : row.isSuccess ? "Done" : "Failed",
               })),
          [result],
     );

     const rowRender = (row, gridRowProps) => {
          if (gridRowProps.dataItem.isSuccess) {
               return row;
          }

          return React.cloneElement(row, {
               ...row.props,
               sx: undefined,
               style: { ...row.props.style, backgroundColor: "rgba(211, 47, 47, 0.12)" },
          });
     };

     return (
          <div>
               <Typography variant="h6" sx={{ mb: 1 }}>
                    {result?.message}
               </Typography>

               <Typography variant="body2" sx={{ mb: 2 }}>
                    {result?.succeeded} imported, {result?.failed} failed,{" "}
                    {result?.skipped} ignored, out of {result?.total} rows sent.
                    {result?.areaManagersCreated > 0 &&
                         ` ${result.areaManagersCreated} area manager${result.areaManagersCreated === 1 ? "" : "s"} created.`}
               </Typography>

               <Grid data={rows} className="sba-area-data-grid" rowRender={rowRender} style={{ maxHeight: GRID_MAX_HEIGHT }}>
                    <GridColumn field="rowNumber" title="Row" width="80px" />
                    <GridColumn field="outcome" title="Outcome" width="110px" />
                    <GridColumn field="dealerCode" title="Dealer Code" width="130px" />
                    <GridColumn field="fullName" title="Name" width="200px" />
                    <GridColumn field="email" title="Email" width="260px" />
                    <GridColumn field="message" title="What happened" width="420px" />
               </Grid>

               <Box sx={{ mt: 2 }}>
                    <Button type="button" themeColor="primary" onClick={onDone}>
                         Done
                    </Button>
               </Box>
          </div>
     );
}
